import React from 'react'
import { useTheme } from 'react-jss'

import { useMobileDetect } from '../../hooks'

import { LightTheme } from '../theme'
import { Column } from '../column'
import { Content } from '../content'
import { Row } from '../row'
import { Text } from '../text'
import { Icon, IconName } from '../icon'

import { FooterProps } from './footer.types'
import { useStyle } from './footer.styles'

export const Footer = <T extends string>({
  className = '',
  aboutText = 'About Us',
  aboutTx,
  termsText = 'Conditions of Use and Privacy Policy',
  termsTx,
  contactInfoTitle = 'Contact Information',
  contactInfoTitleTx,
  contactAddress = '3980 Sherman Street, Suite 170, San Diego, CA 92110\n Email: caret@energycenter.org',
  contactAddressTx,
  copyright = '© Copyright 2022  Center for Sustainable Energy. All Rights Reserved.',
  copyrightTx,
  onPrivacyNavigate,
  onAboutUsNavigate,
  ...props
}: FooterProps<T>) => {
  const theme: LightTheme = useTheme()
  const classes = useStyle({ theme })
  const { isTablet } = useMobileDetect()

  const linkPreset = isTablet ? 'caption' : 'bodyBold'

  return (
    <Column className={classes.content} fullWidth>
      <Content {...props} className={`${className} ${classes.footer}`}>
        <Row
          fullWidth
          justifyContent="space-between"
          alignContent="flex-start"
          alignItems="flex-start"
        >
          <Column alignItems="flex-start" className={classes.col}>
            <Icon name={IconName.LOGO_CSE} width={223} height={81} />
            <Row>
              <Text
                className={classes.navItem}
                text={aboutText}
                tx={aboutTx}
                color="darkBlue"
                preset={linkPreset}
                onClick={onAboutUsNavigate}
              />
              <Text
                className={classes.navItem}
                text={termsText}
                tx={termsTx}
                color="darkBlue"
                preset={linkPreset}
                onClick={onPrivacyNavigate}
              />
            </Row>
          </Column>
          <Column alignItems="flex-start" className={classes.col}>
            <Text text={contactInfoTitle} tx={contactInfoTitleTx} preset="h3" />
            <Text
              text={contactAddress}
              tx={contactAddressTx}
              className={classes.contactInfo}
              color="inactive"
              preset="body"
            />
            <Text
              className={classes.copyright}
              text={copyright}
              tx={copyrightTx}
              preset="smallSubTitleSetting"
            />
          </Column>
        </Row>
      </Content>
    </Column>
  )
}
